import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import {
  Button, Space, Tag, Typography,
} from 'antd';
import React from 'react';
import { priceTransformer } from 'utils';
import { INGREDIENT_CATEGORY_COLORS, INGREDIENT_CATEGORY_LABELS } from './constants';

function getCategoryLabel(value) {
  return INGREDIENT_CATEGORY_LABELS[value] || INGREDIENT_CATEGORY_LABELS.uncategorized;
}

function getCategoryDotColor(value) {
  const categoryValue = value || 'uncategorized';
  const categoryColors = {
    produce: '#52c41a',
    dairy: '#faad14',
    meat: '#ff4d4f',
    pantry: '#d48806',
    bakery: '#eb2f96',
    frozen: '#13c2c2',
    beverages: '#1677ff',
    dry_goods: '#722ed1',
    spices_seasonings: '#fa541c',
    miscellaneous: '#2f54eb',
    uncategorized: '#bfbfbf',
  };
  return categoryColors[categoryValue] || categoryColors.uncategorized;
}

const columns = ({ onEdit, onDelete }) => [
  {
    title: 'Ingredient Name',
    dataIndex: 'name',
    key: 'name',
    render: (value, record) => (
      <Space size={8}>
        <span style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: getCategoryDotColor(record?.category),
          display: 'inline-block',
        }}
        />
        <Typography.Text strong>{value}</Typography.Text>
      </Space>
    ),
  },
  {
    title: 'Unit',
    dataIndex: 'unit',
    key: 'unit',
  },
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category',
    render: (value) => {
      const categoryValue = value || 'uncategorized';
      return (
        <Tag color={INGREDIENT_CATEGORY_COLORS[categoryValue] || 'default'}>
          {getCategoryLabel(value)}
        </Tag>
      );
    },
  },
  {
    title: 'Cost per Unit',
    dataIndex: 'cost_per_unit',
    key: 'cost_per_unit',
    render: (value) => (value ? priceTransformer(value) : '-'),
  },
  {
    title: '',
    key: 'actions',
    width: 80,
    align: 'center',
    render: (_, record) => (
      <Space size="small">
        <Button type="text" icon={<EditOutlined />} onClick={() => onEdit(record)} />
        <Button type="text" icon={<DeleteOutlined />} onClick={() => onDelete(record)} />
      </Space>
    ),
  },
];

export default columns;
